export interface IColorData {
  indexOfSegment: number;
  color: string;
  state?: boolean;
}

export const COLOR_NAMES = {
  0: 'None',
  1: 'Femoral Bone',
  2: 'Femoral Cartilage',
  3: 'Tibial Bone',
  4: 'Tibial Cartilage',
};
